import { render, staticRenderFns } from "./CarProvinceSale.vue?vue&type=template&id=480b7810"
import script from "./CarProvinceSale.vue?vue&type=script&lang=js"
export * from "./CarProvinceSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports